// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1wj6u","inputWrap":"CustomTip_inputWrap__2V8m-"};